import { useLocation } from "react-router-dom";
import BackToTop from "./BackToTop";
import CookieConsent from "./CookieConsent";

/**
 * Renders public-site only widgets (cookie banner, back-to-top).
 * Suppressed on /admin/* where they're noise for the 3-person internal team.
 */
const PublicChrome = () => {
  const { pathname } = useLocation();
  if (pathname.startsWith("/admin")) return null;
  return (
    <>
      <BackToTop />
      <CookieConsent />
    </>
  );
};

export default PublicChrome;
